module.exports = __webpack_public_path__ + "static/sport/h5footer2.ab32077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/h5footer2.png
// module id = Kkma
// module chunks = 0